// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"c6143e47","196":"0d887edc","256":"872c121d","455":"1b96ffdf","468":"dbb625ab","649":"196c01db","768":"94d0157a","857":"5bf5a582","977":"01a868f6"}[chunkId] + ".chunk.js";
};